<div class="message-container" [style.width.px]="width">
  <div *ngIf="isFetchingData" class="message-content">{{'INFLUENCER.module_placeholder.fetching_data_msg' | translate}}</div>
  <div *ngIf="!isFetchingData && hasNoData" class="message-content">{{'INFLUENCER.module_placeholder.empty_data_msg' | translate}}</div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-module-placeholder/influencer-module-placeholder.component.html